module.exports = __webpack_public_path__ + "assets/img/bg.f0897b9c.png";